import { RestaurantPaymentMethodType, RestaurantPaymentMethodTypes } from 'src/constants/RestaurantPaymentMethodType';

export function isPidedirectoPayment(paymentType: RestaurantPaymentMethodType | undefined): boolean {
    return paymentType === RestaurantPaymentMethodTypes.PIDE_DIRECTO;
}
